import { FC, useState } from "react";
import styled from "styled-components";
import ContractService from "../../../services/contract"
import HelperService from "../../../services/helper"
import { Contract } from '../../../models/contract';
import useNotyf from "../../../context/useNotify";
import { useUser } from "../../../context/useUser";
import placeholderImage from "../../../images/common/vgc-logo.png"
import TeamService from "../../../services/team"
import UserService from "../../../services/user"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/free-solid-svg-icons';


interface ViewContractFormProps {
  contract: Contract;
  closeModal: () => void;
}

const ViewContractForm: FC<ViewContractFormProps> = ({ contract, closeModal }) => {
  const notfy = useNotyf();
  const { user, setUser } = useUser();

  // Data
  const [showConfirmation, setShowConfirmation] = useState(false);

  // Api
  const releasePlayer = async () => {
    if (!user) {
      return;
    }
    try {
      await TeamService.releasePlayer(contract.team._id, user?._id);
      notfy.success("Player released successfully");
    } catch (err) {
      console.error(err);
      HelperService.showNotfyErr(notfy, err, "Error releasing player");
    }
  }

  const fetchUser = async () => {
    try {
      const { user } = await UserService.checkToken()
      setUser(user)
    }
    catch (err) {
      console.error(err);
      HelperService.showNotfyErr(notfy, err, "Error fetching user");
    }
  }

  // Methods
  const updateContract = async () => {
    await releasePlayer();
    closeModal();
    fetchUser();
  };

  const handleClickReleaseButton = () => {
    setShowConfirmation(true);
  };

  const handleClickReleaseConfirmationButton = async () => {
    await updateContract();
    // Optionally reset the state or handle additional logic here
  };

  return (
    <div className="h-100 d-flex flex-column justify-content-center p-3">
      <div className="row px-5">
        <div className="col-12">
          <h3 className="text-center heading my-3">Contract Details</h3>
        </div>
      </div>
      <div className="row justify-content-center align-items-center">
        <div className="col-12 col-md-6 text-center">
          <img src={contract.team.image || placeholderImage} alt="Team Logo" className="img-fluid" style={{ maxHeight: '200px' }} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-center d-flex flex-column align-items-center my-2">
          <h5>{contract.team.manager}</h5>
          <h4>{contract.team.name}</h4>
          {/* Show 'manager' if they are manager */}
          {user?._id === contract.team.managerId ? 'Manager' : <p>{contract.seasonsRemaining} seasons remaining</p>}
        </div>
      </div>
      {/* Otherwise if they have premium, show them the premium release button */}
      {user?._id !== contract.team.managerId && user?.isPremium && (
        <div className="row justify-content-center">
          <div className="col-12 col-sm-6">
            {!showConfirmation ? (
              <button
                onClick={handleClickReleaseButton}
                className="btn btn-warning w-100 m-1"
                style={{ backgroundColor: 'gold', borderColor: 'darkgoldenrod' }}
              >
                <FontAwesomeIcon icon={faCrown} className="me-2" />
                Premium Release
              </button>
            ) : (
              <button
                onClick={handleClickReleaseConfirmationButton}
                className="btn btn-warning w-100 m-1"
                style={{ backgroundColor: 'gold', borderColor: 'darkgoldenrod' }}>
                Are you sure?
              </button>
            )}
          </div>
        </div>
      )}
      {/* Otherwise show the release button if they have 0 seasons remaining */}
      {user?._id !== contract.team.managerId && !user?.isPremium && (
      <div className="row justify-content-center">
        <div className="col-12 col-sm-6">
          {!showConfirmation ? (
            <button
              onClick={handleClickReleaseButton}
              className="btn btn-danger w-100 m-1"
              disabled={contract.seasonsRemaining !== 0}>
              Release
            </button>
          ) : (
            <button
              onClick={handleClickReleaseConfirmationButton}
              className="btn btn-danger w-100 m-1">
              Are you sure?
            </button>
          )}
          </div>
      </div>
      )}
    </div>
  );
};

export default ViewContractForm;
